<script setup> 
import PremiumPageHeader from '@/Components/PremiumPageHeader.vue';
import { reactive } from "vue";
// - LRR import { useMainStore } from "@/stores/main";

import SectionMain from "@/Components/SectionMain.vue";
import CardBox from "@/Components/CardBox.vue";
import BaseDivider from "@/Components/BaseDivider.vue";
import FormField from "@/Components/FormField.vue";
import FormControl from "@/Components/FormControl.vue";
import FormFilePicker from "@/Components/FormFilePicker.vue";
import BaseButton from "@/Components/BaseButton.vue";
import BaseButtons from "@/Components/BaseButtons.vue";
import UserCard from "@/Components/UserCard.vue";
//import LayoutAuthenticated from "@/layouts/LayoutAuthenticated.vue";
import BreezeAuthenticatedLayout from '@/Layouts/Authenticated.vue';
import SectionTitleLineWithButton from "@/Components/SectionTitleLineWithButton.vue";
import BreezeInput from '@/Components/Input.vue';
import BreezeLabel from '@/Components/Label.vue';
import BreezeButton from '@/Components/Button.vue';
import { Inertia } from '@inertiajs/inertia';
import { Head, Link, useForm } from '@inertiajs/inertia-vue3';
import BreezeValidationErrors from '@/Components/ValidationErrors.vue';
import {
  mdiAccount,
  mdiMail,
  mdiAsterisk,
  mdiFormTextboxPassword,
  mdiGithub,
  mdiArrowULeftTopBold
} from "@mdi/js";
import BaseIcon from "@/Components/BaseIcon.vue";
// LRR
const props = defineProps({
  object: Object,
  message: String
});

const data = { userName: 'Lenin', userEmail: 'lenin@leninrias.com', userAvatar: '../img/logo.png' }

// LRR
//const mainStore = useMainStore();
const mainStore = data;
//const mainStore = props.userData;
// Hola

/* const profileForm = reactive({
  name: mainStore.userName,
  email: mainStore.userEmail,
}); */

const profileForm = reactive({
  name: props.object ? props.object.name : '',
  email: props.object ? props.object.email : '',
});

//console.log(props.object)

const passwordForm = reactive({
  password_current: "",
  password: "",
  password_confirmation: "",
});

// LRR se  trajo de main store
const setUser = (payload) => {
  if (payload.name) {
    profileForm.userName = payload.name;
  }
  if (payload.email) {
    profileForm.userEmail = payload.email;
  }
  if (payload.avatar) {
    profileForm.userAvatar = payload.avatar;
  }
}

const submitProfile = () => {
  // - LRR mainStore.setUser(profileForm);
  //setUser(profileForm);
  let ruta = 'perfil-actualizar'
  Inertia.put(route(ruta, {
    //'id' : rowID.value,
    'name': profileForm.name,
    'email': profileForm.email
  }
  ))

};

const submitPass = () => {
  //
  let ruta = 'password-actualizar'
  Inertia.put(route(ruta, {
    //'id' : rowID.value,
    'password': passwordForm.password,
    'password_confirmation': passwordForm.password_confirmation
  }
  ))
};
</script>

<template>

  <Head title="Mi Perfil" />

  <BreezeAuthenticatedLayout>
    <template #header>
        <PremiumPageHeader title="Mi Perfil" subtitle="Gestión de mi perfil">
            <template #buttons>
                <Link :href="route('help')" class="btn-small btn-blue btn-icon flex item-center gap-2">
            <span class="hidden lg:inline-flex">Volver a Inicio</span>
            <BaseIcon :path="mdiArrowULeftTopBold" class="text-white" />
          </Link>
            </template>
        </PremiumPageHeader>
    </template>
    <div>
      <div class="bg-white overflow-hidden rounded-md shadow-lg border p-4">

        <BreezeValidationErrors class="mb-4" />
        <div v-if="message">
          <ul class="mt-3 list-disc list-inside text-sm text-green-600">
            <li>{{ message }}</li>
          </ul>
        </div>
        <div class="grid grid-cols-1 lg:grid-cols-2 gap-6">
          <CardBox is-form @submit.prevent="submitProfile">
            <FormField label="Nombre para mostrar" help="Nombre corto o Nickname">
              <FormControl v-model="profileForm.name" :icon="mdiAccount" name="username" required autocomplete="username" />
            </FormField>
            <FormField label="E-mail" help="Email de acceso al sistema">
              <FormControl v-model="profileForm.email" :icon="mdiMail" type="email" name="email" required autocomplete="email" />
            </FormField>
            <BaseButtons>
              <BaseButton color="info" type="submit" label="Guardar" />
            </BaseButtons>

          </CardBox>

          <CardBox is-form @submit.prevent="submitPass">
            <FormField label="Nuevo password" help="Ingresar nuevo password">
              <FormControl v-model="passwordForm.password" :icon="mdiFormTextboxPassword" name="password" type="password" required autocomplete="new-password" />
            </FormField>
            <FormField label="Confirmar password" help="Ingregar el nuevo password una vez más">
              <FormControl v-model="passwordForm.password_confirmation" :icon="mdiFormTextboxPassword" name="password_confirmation" type="password" required autocomplete="new-password" />
            </FormField>

            <BaseButtons>
              <BaseButton type="submit" color="info" label="Guardar" />
            </BaseButtons>

          </CardBox>
        </div>

      </div>

    </div>

  </BreezeAuthenticatedLayout>
</template>
